import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { AuthBootstrapService } from './modules/core/auth/services/auth-bootstrap.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  protected readonly initialAuthenticationSucceeded =
    inject(AuthBootstrapService).initialAuthenticationSucceeded;
}
